export const FACULTY_3_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Faculty cards",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_desktop_image: "",
    meta_name: "",
    meta_designation: "",
    meta_logo: "",
    meta_logo_alt: "Institute logo",
    meta_priority: 1,
    meta_status: true,
  },

  FACULTY_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Title — part before highlight",
      value: "Learning Led by ",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Learning Led by",
      required: false,
      defaultValue: "Learning Led by ",
    },
    {
      fieldName: "title_text_color",
      label: "Title part 1 color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000",
      defaultValue: "#000000",
    },
    {
      fieldName: "title_1",
      label: "Title — highlighted part",
      value: "Distinguished Faculty",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Distinguished Faculty",
      required: false,
      defaultValue: "Distinguished Faculty",
    },
    {
      fieldName: "title_1_color",
      label: "Highlighted title color",
      value: "#E36E26",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#E36E26",
      defaultValue: "#E36E26",
    },
    {
      fieldName: "description",
      label: "Subtitle (18px)",
      value: "India's Strongest Academic Bench in AI & Data Science",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Subtitle below main title",
      required: false,
      defaultValue: "India's Strongest Academic Bench in AI & Data Science",
    },
    {
      fieldName: "description_text_color",
      label: "Subtitle color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000",
      defaultValue: "#000000",
    },
    {
      fieldName: "description_background_color",
      label: "Section background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Faculty section status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable",
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Profile image (276×156)",
      fieldName: "meta_desktop_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload faculty image",
      required: false,
      defaultValue: "",
    },
    {
      header: "Name (16px)",
      fieldName: "meta_name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Faculty name",
      required: false,
      defaultValue: "",
    },
    {
      header: "Designation (14px)",
      fieldName: "meta_designation",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Role / department",
      required: false,
      defaultValue: "",
    },
    {
      header: "Logo (≈114×60)",
      fieldName: "meta_logo",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Institute / crest logo",
      required: false,
      defaultValue: "",
    },
    {
      header: "Logo alt text",
      fieldName: "meta_logo_alt",
      value: "Logo",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Alt text",
      required: false,
      defaultValue: "Logo",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Order",
      required: true,
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable",
      defaultValue: true,
    },
  ],
};
